import { useCustomQuery } from "@/shared/hooks/useCustomQuery";
import CategoryService from "@/features/categories/service/categoryService";

export const useCategoriesData = ({ 
    type = "", 
    page = 1, 
    limit = 10,
    search = ""
}: { 
    type?: "PRESET" | "LEARNING" | ""; 
    page?: number; 
    limit?: number;
    search?: string;
}) => {
    
    return useCustomQuery({
        serviceInstance: CategoryService.Instance,
        selectAction: (service) => service.getCategories,
        parameter: { type, page, limit, search: search || undefined },
        options: {
            staleTime: 1 * 60 * 1000, // 1 minuto
        },
    });
};

export const useAllCategoriesData = () => {
    return useCustomQuery({
        serviceInstance: CategoryService.Instance,
        selectAction: (service) => service.getCategories,
        parameter: { type: "", page: 1, limit: 1000 }, // Limite alto para buscar todas
        options: {
            staleTime: 1 * 60 * 1000, // 1 minuto
        },
    });
};

export const useCategoryData = (id: string) => {
    return useCustomQuery({
        serviceInstance: CategoryService.Instance,
        selectAction: (service) => service.getCategoryById,
        parameter: { id },
        options: {
            enabled: !!id,
            staleTime: 5 * 60 * 1000,
        },
    });
};